import { useQuery } from "react-query";
import { Warranty } from "types/warranty";

export default function useWarranties(price, product_id) {
  /* As Warranties do not change often, enable 15 minutes cache*/
  const { data: warranties } = useQuery<Warranty>(["ecom/warranty", { product_price: price, product_id: product_id }], {
    cacheTime: 1000 * 60 * 15,
    staleTime: 1000 * 60 * 15,
  });
  return warranties;
}
